<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Data Pohon </strong><small>Tambah Data Baru</small>
          </CCardHeader>
          <CCardBody>
            <CForm @submit.prevent="inputPohon">
            <CRow>
              <CCol sm="6">
                <div class="form-group">
                <label>Publish Pohon</label>
                <select v-model="publish" placeholder="Pilihan" class="form-control">
                  <option value="" disabled selected>Pilihan</option>
                  <option value="Ya">Ya</option>
                  <option value="Tidak">Tidak</option>
                </select>
                </div>
              </CCol>
              <CCol sm="12">
                <CInput
                  v-model="name"
                  label="Nama Pohon"
                  placeholder="Input Nama Pohon"
                />
              </CCol>
              
              <CCol sm="6">
                <CInput
                  v-model="no_reg_pohon"
                  label="No Reg Pohon"
                  placeholder="Input No Reg Pohon"
                />
              </CCol>
              <CCol sm="6">
                <div class="form-group">
                <label>Tipe Pohon</label>
                <select v-model="type" placeholder="Pilih Jenis" class="form-control">
                  <option value="" disabled selected>Pilih Jenis</option>
                  <option value="pohonhidup">Pohon Hidup</option>
                  <option value="pohonditebang">Pohon Ditebang</option>
                </select>
                </div>
              </CCol>
              <CCol sm="6">
              <CInput
                v-model="lng"
                label="Longitude Pohon"
                placeholder="Longitude Pohon"
              />  
              </CCol>
              <CCol sm="6">
                <CInput
                  v-model="lat"
                  label="Lattitude Pohon"
                  placeholder="Lattitude Pohon"
                />  
              </CCol> 
              <CCol sm="4">
                <CInput
                  v-model="tinggi"
                  label="Tinggi Pohon"
                  placeholder="Tinggi Pohon"
                />  
              </CCol> 
              <CCol sm="4">
                <CInput
                  v-model="diameter"
                  label="Diameter Pohon"
                  placeholder="Diameter Pohon"
                />  
              </CCol> 
              <CCol sm="4">
                <CInput
                  v-model="lebar_tajuk"
                  label="Lebar Tajuk Pohon"
                  placeholder="Lebar Tajuk Pohon"
                />  
              </CCol> 
              <CCol sm="4">
                <CInput
                  v-model="carbon"
                  label="Carbon Pohon"
                  placeholder="Carbon Pohon"
                />  
              </CCol> 
              <CCol sm="4">
                <CInput
                  v-model="carbondioksida"
                  label="CO2 Pohon"
                  placeholder="CO2 Pohon"
                />  
              </CCol>
              <CCol sm="4">
                <CInput
                  v-model="biomassa"
                  label="Biomasa Pohon"
                  placeholder="Biomasa Pohon"
                />  
              </CCol>

              <!-- <CCol sm="6">
                <div class="form-group">
                  <label>Foto Pohon </label><br/>                  
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" @change="onFileChange2($event)" id="inputGroupFile02"
                    :placeholder="placeholder" aria-describedby="inputGroupFileAddon01">
                    <label class="custom-file-label" for="inputGroupFile01">{{placeholder}}</label>
                  </div>
                </div>  
              </CCol> -->

              <CCol sm="12">
                <CTextarea
                  v-model="address"
                  label="Alamat/Lokasi Pohon"
                  placeholder="Alamat Pohon"
                />  
              </CCol>   
            </CRow>          
                <div class="form-actions">
                  <CButton type="submit" color="primary" style='margin-right:15px'>Simpan</CButton>
                  <CButton color="secondary" to="/pohon">Batal</CButton>
                </div>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Error Input"
      color="danger"
      :show.sync="modalError"
      
    >
      <b>Error</b>! Data Pohon gagal diinput.
    </CModal>
   
  </div>
</template>
<script>
import axios from 'axios';
import * as Modals from '../notifications/Modals.vue'
// import { CurrencyInput } from 'vue-currency-input'

export default {
  // components: {CurrencyInput },
  name: 'Forms',
  data () {
    return {
      publish : "",
      name : "",
      no_reg_pohon : "",
      type : "",
      lng : "",
      lat : "",
      tinggi : "",
      diameter : "",
      lebar_tajuk : "",
      carbon : "",
      carbondioksida : "",
      biomassa : "",
      // foto : "",
      address : "",
      pohon : [],
      selected : [], // Must be an array reference!
      show: true,
      modalError: false,
    }
  },
  methods: {
    
    inputPohon: function(event){
      // Simple POST request with a JSON body using axios
      const pohon = { 
                          publish:this.publish,
                          name:this.name,
                          no_reg_pohon: this.no_reg_pohon, 
                          type: this.type, 
                          lng: this.lng, 
                          lat: this.lat, 
                          tinggi: this.tinggi, 
                          diameter: this.diameter, 
                          lebar_tajuk: this.lebar_tajuk, 
                          carbon: this.carbon, 
                          carbondioksida: this.carbondioksida, 
                          biomassa: this.biomassa, 
                          // foto: this.foto,
                          address: this.address
                          };
      // alert(JSON.stringify(anggota));
      axios.post(process.env.VUE_APP_BASE_URL+"api/public/index.php/addpohon/?key=$2y$10$AnZ411EfYcBHTEMMYbXni.7HuKm5nf4fCleVEKMPs9dsDRKlrLCPu", pohon)
        .then((response) => {
            // console.log(response);
            // alert(response.data);
            if(response.data=='sukses'){
              this.$router.push('/pohon');
            }
            else{
              this.modalError = true;
            }            
        })
    }
  }
}
</script>